import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VChip,{staticClass:"cronometro",attrs:{"label":"","dark":"","color":_vm.colorCronometro}},[_c('span',[_vm._v(_vm._s(_vm.formatRestante()))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }